module.exports = __webpack_public_path__ + "img/diyi.d3d93de6.png";